import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model, referenceOne } from 'libx';
import map from 'lodash/map';
import { computed, observable } from 'mobx';
import moment from 'moment';
import { DELIVERED, READ, SENT } from '../consts/MessageReceiptState';
import { markdownToHtml } from '../utils/markdownUtil';
var Message = (_dec = observable.shallow, _class = /*#__PURE__*/function (_Model) {
  function Message() {
    var _this;
    _classCallCheck(this, Message);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Message, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "text", _descriptor2, _this);
    _initializerDefineProperty(_this, "senderUserId", _descriptor3, _this);
    _initializerDefineProperty(_this, "senderUserPublicId", _descriptor4, _this);
    _initializerDefineProperty(_this, "conversationId", _descriptor5, _this);
    _initializerDefineProperty(_this, "sentAt", _descriptor6, _this);
    _initializerDefineProperty(_this, "allRecipientStatuses", _descriptor7, _this);
    _initializerDefineProperty(_this, "type", _descriptor8, _this);
    _initializerDefineProperty(_this, "workspaceId", _descriptor9, _this);
    _initializerDefineProperty(_this, "content", _descriptor10, _this);
    return _this;
  }
  _inherits(Message, _Model);
  return _createClass(Message, [{
    key: "sender",
    get: function get() {
      var job = this.rootStore.jobStore.forConversation(this.conversationId);
      if (!job || !this.senderUserId || !this.senderUserPublicId) {
        return null;
      }
      return this.rootStore.memberStore.forWorkspaceAndUserPublicId(job.workspaceId, this.senderUserPublicId);
    }
  }, {
    key: "conversation",
    get: function get() {
      return referenceOne(this.rootStore.messageStore.conversations, this.conversationId);
    }
  }, {
    key: "receiptState",
    get: function get() {
      var receiptState = null;
      if (this.hasRecipientStatus(SENT)) {
        receiptState = SENT;
      }
      if (this.hasRecipientStatus(DELIVERED)) {
        receiptState = DELIVERED;
      }
      if (this.hasRecipientStatus(READ)) {
        receiptState = READ;
      }
      return receiptState;
    }
  }, {
    key: "isRead",
    get: function get() {
      if (this.type === null) {
        return true;
      }
      var status = this.myRecipientStatus;
      return status && status.status === READ;
    }
  }, {
    key: "recipientStatus",
    get: function get() {
      var _this2 = this;
      return this.allRecipientStatuses.filter(function (x) {
        return x !== _this2.myRecipientStatus;
      });
    }
  }, {
    key: "textRendered",
    get: function get() {
      return markdownToHtml(this.text);
    }
  }, {
    key: "myRecipientStatus",
    get: function get() {
      var _this3 = this;
      return this.allRecipientStatuses.find(function (x) {
        return x.recipientUserId === _this3.rootStore.sessionStore.member.userId;
      });
    }
  }, {
    key: "hasRecipientStatus",
    value: function hasRecipientStatus(status) {
      return this.recipientStatus.some(function (x) {
        return x.status === status;
      });
    }
  }, {
    key: "parse",
    value: function parse(json, opts) {
      var createdHere = opts ? opts.createdHere : false;
      var id = json.id;
      var part = {
        body: json.content.text
      };
      var conversationId = json.conversation_id;
      var sentAt = json.date_created;
      var recipientStatus = json.statuses;
      var sender = {
        userId: json.user_id,
        userPublicId: json.user_public_id
      };
      var job = this.rootStore.jobStore.forConversation(conversationId);
      var data = {
        id: id,
        createdHere: createdHere,
        conversationId: conversationId,
        type: json.content.type,
        sentAt: moment(sentAt),
        allRecipientStatuses: this._mapRecipientStatus(recipientStatus),
        senderUserId: sender.userId ? decodeURIComponent(sender.userId) : undefined,
        senderUserPublicId: sender.userPublicId ? sender.userPublicId : undefined,
        text: part.body,
        // lol sue me
        content: this._parseContent(json.content, conversationId, job ? job.id : '')
      };
      if (job && job.workspaceId && data.senderUserId) {
        this.rootStore.memberStore.setAndFetch({
          user_id: data.senderUserId,
          user_public_id: data.senderUserPublicId,
          workspace_id: job.workspaceId
        });
      }
      return data;
    }
  }, {
    key: "_parseContent",
    value: function _parseContent(contentDto, convoId, jobId) {
      if (!contentDto) {
        return undefined;
      }
      switch (contentDto.type) {
        case 'CALL':
          {
            var primedCall = this.rootStore.callStore.primeCall({
              id: contentDto.call_id,
              conversation_id: convoId
            });
            return {
              type: 'Call',
              call: primedCall
            };
          }
        case 'EXTERNAL_REFERENCE':
          {
            switch (contentDto.external_type) {
              case 'worklayer.jobs.Prompt':
                {
                  return {
                    type: 'Prompt',
                    prompt: this.rootStore.promptStore.primePrompt({
                      id: contentDto.external_id
                    })
                  };
                }
              case 'worklayer.jobs.Progression':
                {
                  return {
                    type: 'Progression',
                    stepId: contentDto.external_id,
                    progression: this.rootStore.jobProgressionStore.primeProgression({
                      jobId: jobId
                    })
                  };
                }
              case 'worklayer.jobs.assistant.OpenAI':
                {
                  return {
                    type: 'Assistant',
                    externalReplyId: contentDto.external_id
                  };
                }
            }
            return createFallbackContent(contentDto.text);
          }
        default:
          {
            return createFallbackContent(contentDto.text);
          }
      }
    }
  }, {
    key: "_mapRecipientStatus",
    value: function _mapRecipientStatus(recipientStatus) {
      var convoId = this.conversationId;
      var _this$rootStore = this.rootStore,
        jobStore = _this$rootStore.jobStore,
        memberStore = _this$rootStore.memberStore;
      return map(recipientStatus, function (s) {
        var id = s.user_id;
        var publicId = s.user_public_id;
        var job = jobStore.forConversation(convoId);
        if (job) {
          memberStore.setAndFetch({
            workspace_id: job.workspaceId,
            user_id: id,
            user_public_id: publicId
          });
        }
        return observable({
          status: s.status,
          recipientUserId: id,
          get recipient() {
            return job ? memberStore.forWorkspaceAndUserPublicId(job.workspaceId, publicId) : null;
          }
        });
      });
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "text", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "senderUserId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "senderUserPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "conversationId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sentAt", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return moment();
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "allRecipientStatuses", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "type", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'text';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "content", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      type: 'Text',
      text: ''
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "sender", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sender"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conversation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "conversation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "receiptState", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "receiptState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isRead", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isRead"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recipientStatus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recipientStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "textRendered", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "textRendered"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "myRecipientStatus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "myRecipientStatus"), _class.prototype), _class);
export default Message;

/**
 * Creates fallback content in case we can't parse the content type.
 *
 * @param {string} text
 */
function createFallbackContent(text) {
  return {
    type: 'Text',
    text: text || '_no message_'
  };
}
//# sourceMappingURL=Message.js.map
